import React from 'react';
import { Link } from 'react-router-dom';

function DataReset() {
    return (
        <>
            <section className='landing_page_main'>
                <section className='cms_page_top_section'>
                    <div className='page_title_section'>
                        <h1>Reset Your BYP Budget Data</h1>
                        <div className='breadcrumb_section'>
                            <ul className="breadcrumb">
                                <li><Link to="/">Home</Link></li>
                                <li> Reset Budget Data</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className='cms_content_section list_li_bold'>
                    <div className='container'>
                        <p>BYP allows you to reset your budgeting data without deleting your BYP account.</p>

                        <div className='mt-70'>
                            <h3>How to reset your budget</h3>
                            <ol className='list_about'>
                                <li>Open BYP and sign in to your account.</li>
                                <li>Open Settings.</li>
                                <li>Select <strong>Reset My Budget</strong>.</li>
                                <li>Follow the prompts to confirm the reset.</li>
                            </ol>
                        </div>

                        <div className='mt-70'>
                            <h3>What the reset affects</h3>
                            <p>Resetting your budget removes your current budgeting setup so you can start fresh. This may include your current income, expenses, savings setup, planned expenses, allowance setup, and paycheck-planning information.</p>
                            <p>Your BYP account remains available after the reset, so you can continue using the same account and create a new budget.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>Delete your entire account instead</h3>
                            <p>If you want to permanently delete your BYP account and associated personal data rather than reset only your budgeting information, visit our <Link to="/delete-account">account deletion page</Link> or use <strong>Delete Account</strong> within the BYP app.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>Need assistance?</h3>
                            <p>For help with a budget reset or other data request, contact us at <a href="mailto:info@bypapp.com">info@bypapp.com</a>.</p>
                        </div>
                    </div>
                </section>
            </section>
        </>
    );
}

export default DataReset;
